import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "mt-7" };
const _hoisted_4 = { key: 0 };
import { ref, onMounted, getCurrentInstance } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useApi } from '@/composables/useApi';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { useTransactions } from '@/composables/useTransactions';
import { useSpending } from '@/composables/useSpending';
import { useVouchers } from '@/composables/useVouchers';
import { useMoves } from '@/composables/useMoves';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoadTestPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const { login } = useApi();
        const { getCustomer } = useCustomer();
        const { getBankingInfo } = useBanking();
        const { getTransaction, getTransactionClassifications, updateTransactionClassificationMerchantRule } = useTransactions();
        const { getSpendingAnalysisStructured, getSpendingPlansLite } = useSpending();
        const { getAvailableVouchers } = useVouchers();
        const { getPendingMoves } = useMoves();
        const iterations = ref(10);
        const counter = ref(0);
        const time = ref(null);
        const times = ref([]);
        const running = ref(false);
        async function onLoad() {
            state.useCache = false;
            running.value = true;
            var start = new Date();
            for (var x = 0; x < iterations.value; x++) {
                counter.value++;
                await work(x);
            }
            var end = new Date();
            time.value = end.getTime() - start.getTime();
            console.log('Time taken: ' + time.value + 'ms');
            times.value.push(time.value);
            counter.value = 0;
            running.value = false;
        }
        async function work(x) {
            var done = false;
            login(cookies?.get('user'), cookies?.get('pass'), () => {
                getCustomer(() => {
                    getBankingInfo(() => {
                        var transId = state.bankInfo.accounts[0].transactions[0].id;
                        console.log('Transaction ID: ' + transId);
                        getTransaction(transId, (trans) => {
                            getTransactionClassifications(() => {
                                var cat = state.transactionClassifications[x];
                                var post = { "alwaysExcludeFromAnalysis": false,
                                    "merchantName": trans.merchantName,
                                    "chosenTransactionClassification": {
                                        "mgClassification": cat.mgClassification.mgClassification,
                                        "mgSubClassification": cat.mgClassification.mgSubClassification,
                                        "grandParentClassification": cat.mgClassification.grandParentClassification
                                    } };
                                updateTransactionClassificationMerchantRule(post, () => {
                                    getSpendingAnalysisStructured(() => {
                                        getSpendingPlansLite(() => {
                                            getAvailableVouchers(() => {
                                                getPendingMoves(() => {
                                                    done = true;
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
            while (!done) {
                await new Promise(resolve => setTimeout(resolve, 100));
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Load Tester" }),
                _createVNode(CustomerLoadWait, {
                    customer: !running.value
                }, null, 8, ["customer"]),
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("p", null, "This page will give you a simple benchmark of system performance, it runs common functions and awaits their return. ", -1)),
                    _createElementVNode("p", null, "Iteration: " + _toDisplayString(counter.value) + " of " + _toDisplayString(iterations.value), 1),
                    (time.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Time taken to complete: " + _toDisplayString(time.value) + "ms", 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                        (times.value.length > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Average: " + _toDisplayString(times.value.reduce((aac, c) => aac + c, 0) / times.value.length) + "ms over " + _toDisplayString(times.value.length) + " run(s) ", 1))
                            : _createCommentVNode("", true),
                        (!running.value)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                onClick: onLoad,
                                color: "primary"
                            }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("Run Again")
                                ])),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 64));
        };
    }
});
